import { c as _c } from "react/compiler-runtime";
import React from 'react';
interface WaveDropPartTitleProps {
  title: string | null;
}
const WaveDropPartTitle: React.FC<WaveDropPartTitleProps> = t0 => {
  const $ = _c(2);
  const {
    title
  } = t0;
  if (!title) {
    return null;
  }
  let t1;
  if ($[0] !== title) {
    t1 = <p className="tw-font-semibold tw-text-iron-100 tw-text-md tw-mb-0">{title}</p>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default WaveDropPartTitle;